import { OK } from 'http-status-codes';

export default class BaseApiService {
  protected readonly headers = {
    'Content-Type': 'application/json; charset=utf-8',
  };

  private async tryGetResponse<TIn, TOut>(response: Response): Promise<TOut> {
    const { status } = response;
    if (status !== OK) {
      let data = response;
      try {
        data = await response.json();
      } catch (e) {
        //
      }
      throw data;
    }
    return response.json();
  }

  protected async mapResponse<TIn, TOut>(response: Response, mapper: (resp: TIn) => TOut): Promise<TOut> {
    const data: TIn = await this.tryGetResponse(response);
    return mapper(data);
  }

  protected mapRequest<TIn, TOut>(data: TIn, mapper: (data: TIn) => TOut): TOut {
    return mapper(data);
  }
}
